export const CLARA_AVATAR = "https://static.prod-images.emergentagent.com/jobs/2957faa5-eff2-477e-8930-90a157c15082/images/a4c64fcdcb442c025ce5163640e87101646cdc3a4436c3238612a6beb21844f4.jpeg";

export const ClaraAvatar = ({ size = "h-10 w-10", online = true, ring = "border-ac-band" }) => (
  <span className={`relative inline-block shrink-0 ${size}`}>
    <img src={CLARA_AVATAR} alt="Clara" className="h-full w-full scale-110 rounded-full object-cover" />
    <span className="pointer-events-none absolute inset-0 rounded-full ring-2 ring-white/40" />
    {online && <span className={`absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full border-2 ${ring} bg-emerald-400`} />}
  </span>
);

export const BrandMark = ({ className = "h-9 w-9" }) => (
  <span className={`relative grid place-items-center ${className}`}>
    <span className="ac-drop absolute inset-0" />
    <span className="relative mt-1 h-2 w-3 rounded-full bg-ac-accent shadow-[0_0_8px_rgba(255,122,26,0.8)]" />
  </span>
);
